import { logger } from '@/shared/helpers/logger';
import { useAppDispatch } from '@/shared/hooks/useStore';
import { writeOpenedVersion } from '@/viewmodel/shared/versionCheck/state/announcementStorage';
import { panelOpened } from '@/viewmodel/shared/versionCheck/state/versionCheckSlice';
import type { ReleaseAnnouncements } from '@/viewmodel/shared/versionCheck/types';
import { useCallback } from 'react';

export function useOpenAnnouncements(
  userId: string | null,
): (release: ReleaseAnnouncements) => void {
  const dispatch = useAppDispatch();

  return useCallback(
    (release: ReleaseAnnouncements): void => {
      dispatch(panelOpened({ seenVersion: release.version }));
      if (userId) {
        writeOpenedVersion(userId, release.version);
      } else {
        logger.info('versionCheck: panel opened with no user id; dismissal is session-only', {
          log_source: 'useOpenAnnouncements',
        });
      }
    },
    [dispatch, userId],
  );
}
